export const SET_SELECT_MODE = "SET_SELECT_MODE";
export const SET_SELECT_ALL = "SET_SELECT_ALL";
export const ADD_CURRENT_SELECTED_ITEMS = "ADD_CURRENT_SELECTED_ITEMS";
export const REMOVE_CURRENT_SELECTED_ITEMS = "REMOVE_CURRENT_SELECTED_ITEMS";
export const RESET_CURRENT_SELECTED_ITEMS = "RESET_CURRENT_SELECTED_ITEMS";
